export function Pillars() {
    const pillars = [
        { icon: "🎯", color: "bg-blue-50 text-blue-500", title: "Autonomie totale", desc: "Gérez vous-même vos produits, vos prix, vos horaires. Changez le plat du jour en 30 secondes. Fermez exceptionnellement en un tap. Tout depuis votre téléphone." },
        { icon: "💰", color: "bg-emerald-50 text-emerald-500", title: "Zéro commission", desc: "Vous payez 180€/an — c'est tout. Pas de pourcentage sur vos ventes. Stripe prélève ses frais bancaires standards (1,4% + 0,25€ par transaction), le minimum incompressible." },
        { icon: "📱", color: "bg-orange-50 text-orange-500", title: "Votre propre application", desc: "Vos clients installent votre marque sur leur téléphone. Votre logo, vos couleurs, votre nom. C'est votre vitrine digitale, pas celle d'une plateforme." },
    ];

    return (
        <section className="py-12 px-6" id="solution">
            <div className="text-center mb-12">
                <h2 className="text-[clamp(1.75rem,4vw,2.75rem)] font-extrabold text-slate-900 leading-[1.2] tracking-tight mb-4">
                    Simple, autonome, abordable.
                </h2>
                <p className="text-[clamp(1.05rem,2vw,1.25rem)] text-slate-500 max-w-[680px] mx-auto leading-relaxed">
                    Une solution clé en main pensée pour les petits entrepreneurs. Pas besoin d'être un expert en informatique.
                </p>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 max-w-[1200px] mx-auto">
                {pillars.map(p => (
                    <div key={p.title} className="bg-white rounded-2xl p-9 shadow-md border border-slate-200 transition-all hover:-translate-y-1 hover:shadow-lg">
                        <div className={`w-14 h-14 rounded-xl flex items-center justify-center text-[1.6rem] mb-5 ${p.color}`}>{p.icon}</div>
                        <h3 className="text-[clamp(1.25rem,2.5vw,1.5rem)] font-extrabold text-slate-900 mb-2">{p.title}</h3>
                        <p className="text-slate-500 leading-relaxed">{p.desc}</p>
                    </div>
                ))}
            </div>
        </section>
    );
}
